import placeApi from '@src/services/api/place';
import { PlaceItemType, PlaceListType } from '@src/types/place';
import { useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import Button from '@src/components/ui/atoms/button';
import { Link } from 'react-router-dom';

function formatDate(value: string) {
  const tz = 'Asia/Seoul';
  const seoulDate = dayjs(value).tz(tz);
  return seoulDate.format('YYYY-MM-DD HH:mm:ss');
}

const Container = styled.div`
  padding: 30px 12px;
  table,
  th,
  td {
    border: 1px solid black;
    border-collapse: collapse;
  }
  display: grid;
  grid-template-columns: 700px 500px;
  gap: 20px;
`;

export default function BookingPlaces() {
  const [placeList, setPlaceList] = useState<PlaceListType[]>([]);
  const [bizItems, setBizItems] = useState<PlaceItemType[]>([]);
  const _placeList = useRef<PlaceListType[]>();
  const _bizItems = useRef<PlaceItemType[]>([]);
  const [serverNow, setServerNow] = useState('');
  const [naverNow, setNaverNow] = useState('');
  const [diff, setDiff] = useState<any>();

  const getPlaceList = async () => {
    const { data } = await placeApi.getList();
    setPlaceList(data);
    _placeList.current = data;
  };

  const getBizItems = async (bizId: string) => {
    const { data } = await placeApi.getBizItemsList(bizId);
    _bizItems.current = data;
    setBizItems(data);
  };

  const updateBizItems = async (bizId: string) => {
    const { data } = await placeApi.updateBizItems(bizId);
    setBizItems(data);
  };

  const getServerTime = async () => {
    const { data } = await placeApi.getServerTime();
    setServerNow(dayjs(data.now).format('YYYY-MM-DD hh:mm:ss:SSS'));
    setNaverNow(dayjs(data.naver).format('YYYY-MM-DD hh:mm:ss:SSS'));
    setDiff(data.diff);
  };

  const updateBizSchedule = async (itemId: string[]) => {
    const { code } = await placeApi.updateBizSchedule(placeList[0].business_type_id, placeList[0].business_id, itemId);
    if (code === 200) {
      alert('success');
    }
  };

  const updateBizScheduleAll = async () => {
    const itemIds = _bizItems.current
      // .filter(({ booking_date }) => new Date(booking_date) > new Date())
      .map(({ item_id }) => item_id);
    console.log(itemIds);
    const { code } = await placeApi.updateBizSchedule(placeList[0].business_type_id, placeList[0].business_id, itemIds);
    if (code === 200) {
      alert('success');
    }
  };

  useLayoutEffect(() => {
    getPlaceList();
  }, []);
  return (
    <Container>
      <div>
        <Button onClick={getServerTime}>Get Time Diff</Button>
        <p>{serverNow}</p>
        <p>{naverNow}</p>
        <p>{JSON.stringify(diff)}</p>
      </div>
      <table>
        <thead>
          <tr>
            <td>id</td>
            <td>name</td>
            <td>updated</td>
            <td>refresh</td>
          </tr>
        </thead>
        <tbody>
          {placeList.map(place => (
            <tr key={place.business_id}>
              <td>{place.business_id}</td>
              <td>
                <a onClick={() => getBizItems(place.business_id)}>{place.business_name}</a>
              </td>
              <td>{formatDate(place.updated_at)}</td>
              <td>
                <Button onClick={() => updateBizItems(place.business_id)}>refresh</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div>
        <table>
          <thead>
            <tr>
              <td>id</td>
              <td>name</td>
              <td>booking date</td>
              <td>
                <Button onClick={updateBizScheduleAll}>All</Button>
              </td>
            </tr>
            {bizItems.map(item => (
              <tr key={item.item_id}>
                <td>
                  <Link to={`/admin/booking-place-list/schedule/${item.item_id}`}>{item.item_id}</Link>
                </td>
                <td>{item.name}</td>
                <td>refresh</td>
                <td>{formatDate(item.booking_date)}</td>
                <Button onClick={() => updateBizSchedule([item.item_id])}>refresh</Button>
              </tr>
            ))}
          </thead>
        </table>
      </div>
    </Container>
  );
}
